import DropdownMenu from "@/components/DropdownMenu";
import TargetLink from "@/components/TargetLink";
import { useInformationsLazyQuery } from "@/hooks";
import config from "@/lib/config";
import routes from "@/lib/routes";
import dropDownStyles from "@/styles/DropdownMenu.module.scss";
import styles from "@/styles/Header.module.scss";
import classnames from "classnames";
import Link from "next/link";
import { memo, useCallback, useEffect, useState } from "react";
import IconBell from "../../../src/svgs/icon_bell.svg";

function Notice() {
  const [getInformations, { data }] = useInformationsLazyQuery();
  const [badge, setBadge] = useState(false);

  const informations = data?.informations?.data;
  const totalCount = data?.informations?.pageInfo?.totalCount || 0;

  const handleListClick = useCallback(() => {
    const latest = informations[0];
    if (latest) {
      window.localStorage.setItem("currentInformarion", latest.id);
      setBadge(false);
    }
  }, [informations]);

  useEffect(() => {
    const key = config.information["vod"];
    getInformations({ variables: { key, offset: 0, limit: 10 } });
  }, []);

  useEffect(() => {
    if (informations) {
      const latest = informations[0];
      if (latest) {
        window.localStorage.setItem("latestInformation", latest.id);
        const current = window.localStorage.getItem("currentInformarion");
        if (latest.id != current) {
          setBadge(true);
        }
      }
    }
  }, [informations]);

  return (
    <div className={styles.notice}>
      <DropdownMenu
        right
        button={
          <a className={styles.noticeBtn}>
            <div
              className={classnames(styles.noticeIcon, {
                [styles.hasNotice]: badge,
              })}
            >
              <IconBell />
            </div>
          </a>
        }
        scopedClass={dropDownStyles.forHeaderMenu}
      >
        <div className={styles.noticeList}>
          <div className={styles.inner}>
            <div className={styles.list}>
              {informations && (
                <ul>
                  {informations.map((info) => (
                    <li key={`notice-${info.id}`}>
                      <span className={styles.noticeDate}>
                        {info.date && info.date}
                      </span>
                      <TargetLink href={info.url} blank={info.targetBlank}>
                        {info.title}
                      </TargetLink>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className={styles.index}>
              {totalCount > 0 && (
                <Link href={routes.informations} onClick={handleListClick}>
                  お知らせ一覧へ
                </Link>
              )}
              {totalCount == 0 && <span>お知らせはありません</span>}
            </div>
          </div>
        </div>
      </DropdownMenu>
    </div>
  );
}
export default memo(Notice);
